// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__prsrF","type":"styles_type__3g4I8","choices":"styles_choices__3Sj36"};